/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Awsresourceenabled2Inputs */

const en_entity_awsresourceenabled2 = /** @type {(inputs: Entity_Awsresourceenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AWS Resource Enabled`)
};

const de_entity_awsresourceenabled2 = /** @type {(inputs: Entity_Awsresourceenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AWS-Ressource aktiviert`)
};

/**
* | output |
* | --- |
* | "AWS Resource Enabled" |
*
* @param {Entity_Awsresourceenabled2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_awsresourceenabled2 = /** @type {((inputs?: Entity_Awsresourceenabled2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Awsresourceenabled2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_awsresourceenabled2(inputs)
	return de_entity_awsresourceenabled2(inputs)
});
export { entity_awsresourceenabled2 as "entity_awsResourceEnabled" }